import PropTypes from "prop-types";
import React from "react";
import { primary } from "../palette";

export default function Link({ entityKey, contentState, children }) {
  const { url } = contentState.getEntity(entityKey).getData();

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      css={{
        color: primary,
        textDecoration: "none",
        cursor: "pointer",
      }}
    >
      {children}
    </a>
  );
}

Link.propTypes = {
  entityKey: PropTypes.string.isRequired,
  contentState: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
};
